import Quill, * as QuillNamespace from 'quill';
import Delta from 'quill-delta';

const Clipboard = Quill.import('modules/clipboard') as any;
const Quill_lib: any = QuillNamespace;

export class CustomClipboard extends Clipboard {
  onPasteLib(e: ClipboardEvent) {
    if (e.defaultPrevented || !this['quill'].isEnabled()) return;

    const range = this['quill'].getSelection();
    let delta = new Delta().retain(range.index);
    const scrollTop = this['quill'].scrollingContainer.scrollTop;

    this['container'].focus();
    this['quill'].selection.update(Quill_lib.sources.SILENT);

    setTimeout(() => {
      delta = delta.concat(this['convert']()).delete(range.length);
      this['quill'].updateContents(delta, Quill_lib.sources.USER);
      // range.length contributes to delta.length()
      this['quill'].setSelection(delta.length() - range.length, Quill_lib.sources.SILENT);
      this['quill'].scrollingContainer.scrollTop = scrollTop;
      this['quill'].focus();
    }, 1);
  }

  // Alternative implementation (commented out for reference)
  onPaste(e: ClipboardEvent) {
    if (e.defaultPrevented || !this['quill'].isEnabled()) return;

    const clipboardData = e.clipboardData;
    if (!clipboardData) return;

    const html = clipboardData.getData('text/html');
    const text = clipboardData.getData('text/plain');
    const hasFile = clipboardData.getData('image/png');

    if (html || text) {
      const scrollTop = this['quill'].scrollingContainer.scrollTop;
      const delta = html ? this['convert'](html) : new Delta().insert(text);

      setTimeout(() => {
        const range = this['quill'].getSelection();
        const index = range ? range.index : this['quill'].getLength();
        this['quill'].updateContents(new Delta().retain(index).concat(delta), Quill_lib.sources.USER);
        // Move cursor to end of pasted content
        this['quill'].setSelection(index + delta.length(), Quill_lib.sources.SILENT);
        this['quill'].scrollingContainer.scrollTop = scrollTop;
        this['quill'].focus();
      }, 1);
      return;
    }

    super.onPaste(e);
  }
}
